import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"

//i18n
import { withTranslation } from "react-i18next"
// Redux
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import withRouter from "components/Common/withRouter"

// users

const ProfileMenu = props => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false)

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item d-flex align-items-center "
          id="page-header-user-dropdown"
          tag="button"
        >
          <i className="bx bx-user-circle" style={{ fontSize: 24 }}></i>
          {/* <img
            className="rounded-circle header-profile-user"
            src={user1}
            alt="Header Avatar"
          /> */}
          {/* <span className="d-none d-xl-inline-block ms-2 me-1">{username}</span> */}
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end header_dropdown">
          <DropdownItem tag="p" href="#">
            <Link to={"/profile"}>
              <i className="bx bx bx-user font-size-16 align-middle me-1" />
              {props.t("My Profile")}
            </Link>
          </DropdownItem>
          <DropdownItem tag="p" href="#">
            <Link to={"/change-password"}>
              <i className="bx bx bx-key font-size-16 align-middle me-1" />
              {props.t("Change Password")}
            </Link>
          </DropdownItem>
          <DropdownItem tag="p" href="#">
            <Link to={"/my-preference"}>
              <i className="bx bx-wrench font-size-16 align-middle me-1" />
              {props.t("My Preferences")}
            </Link>
          </DropdownItem>
          <DropdownItem tag="p" href="#">
            <Link to={"/my-preference?tab=THEME_LOGO"}>
              <i className="bx bx-palette font-size-16 align-middle me-1" />
              {props.t("Theme & Logo")}
            </Link>
          </DropdownItem>
          <DropdownItem tag="p" href="#">
            <Link to={"/export-requests"}>
              <i className="bx bx-export font-size-16 align-middle me-1" />
              {props.t("Export Requests")}
            </Link>
          </DropdownItem>
          <div className="dropdown-divider" />
          <Link to="/logout" className="dropdown-item">
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>{props.t("Logout")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  )
}

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(ProfileMenu))
